module.exports = __webpack_public_path__ + "static/media/map.2c9f6723.png";